import { Controller } from "@hotwired/stimulus"

// Auto-advances a single-question, single-select onboarding step: picking an
// option submits the form (advancing to the next step) with no Next button.
// A brief beat lets the selected state — driven by CSS :has(input:checked) —
// paint first, so the tap is visually confirmed before the page navigates.
export default class extends Controller {
  static values = { delay: { type: Number, default: 130 } }

  advance() {
    // Fired on both `change` and `click`: `change` covers keyboard selection,
    // `click` lets a user who navigated back re-pick the already-checked option
    // (which fires no `change`). Guard so a fresh mouse selection — which fires
    // both — only submits once.
    if (this.advancing) return
    this.advancing = true

    setTimeout(() => this.submit(), this.delayValue)
  }

  submit() {
    // Prefer the native form submit (respects data-turbo=false and HTML
    // validation); fall back for older browsers without requestSubmit.
    if (typeof this.element.requestSubmit === "function") {
      this.element.requestSubmit()
    } else {
      this.element.submit()
    }
  }
}
